import { render, staticRenderFns } from "./DisputedCharges.vue?vue&type=template&id=0c474a73"
import script from "./DisputedCharges.vue?vue&type=script&lang=js"
export * from "./DisputedCharges.vue?vue&type=script&lang=js"
import style0 from "./DisputedCharges.vue?vue&type=style&index=0&id=0c474a73&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports